import React from 'react'
import {MaterialApoyo} from "../components/marketing/MaterialApoyo";

export const MaterialApoyoPage = () => {
    return (
        <MaterialApoyo/>
    )
}
